import React from 'react'

import withDefaultStyles from './withDefaultStyles'

const FillCrownPsima = () => (
  <svg
    data-dc-tpl="57"
    width="13"
    height="13"
    viewBox="0 0 24 24"
    fill="#6366F1"
    stroke="#6366F1"
    strokeWidth="1.4"
    strokeLinejoin="round"
  >
    <path
      data-dc-tpl="58"
      d="M11.562 3.266a.5.5 0 0 1 .876 0L15.39 8.87a1 1 0 0 0 1.516.294L21.183 5.5a.5.5 0 0 1 .798.519l-2.834 10.246a1 1 0 0 1-.956.734H5.81a1 1 0 0 1-.957-.734L2.02 6.02a.5.5 0 0 1 .798-.519l4.276 3.664a1 1 0 0 0 1.516-.294z"
    />
  </svg>
)

export default withDefaultStyles(FillCrownPsima)
